import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { locales } from 'constants/common';
import { useStore } from 'hooks/useStore';

import { News } from './News';

import css from './Media.module.css';

const Media = () => {
  const {
    app: { env, searchResult, locale },
  } = useStore();

  return (
    <div className={css.container}>
      <div className={css.banners}>
        {locale === locales.ru && (
          <>
            <div className={cn(css.banner, 'user-data-grid')} min-screen-width="400">
              <span ati-userdata-info="doc-preset=allpages_300_300" />
            </div>

            <div className={cn(css.banner, 'user-data-grid')} min-screen-width="400">
              <span ati-userdata-info="doc-preset=allpages_300_300" />
            </div>
          </>
        )}

        {env && <News env={env} />}
      </div>

      {locale === locales.ru && (
        <div className={css.wideBanner}>
          <span ati-userdata-info="doc-preset=allpages_940_200" />
        </div>
      )}

      <div
        className={cn('truckmarket-widget', css.truckMarket, {
          hidden: searchResult,
        })}
      ></div>
    </div>
  );
};

const connected = observer(Media);

export { connected as Media };
